export class Presupuesto {
    idPresupuesto: number;
    status: string;
    ordenServicio: string;
    fechaPresupuesto: Date;
    fechaActualizacion: Date;
    fechaAutorizacion: Date;
    fechaAceptacion: Date;
    total: number;
    utilidad: number;
    costoManoObra: number;
    porcentajeUtilidad: number;
    manoObraAutorizado: number;
    montoAutorizado: number;
    observaciones: string;
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/presupuesto.ts